export default "__VITE_ASSET__CntyRktm__"